/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_Step_HeadingInputs */

const en_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your settings`)
};

const fr_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez vos paramètres`)
};

const de_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen Sie Ihre Einstellungen`)
};

const it_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi le tue impostazioni`)
};

const ru_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте свои настройки.`)
};

const es_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu configuración`)
};

const zh_cn2_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看您的设置`)
};

const ja_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を確認してください`)
};

const hi_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी सेटिंग्स की समीक्षा करें`)
};

const pt_pt2_new_project_confirm_step_heading = /** @type {(inputs: New_Project_Confirm_Step_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise suas configurações`)
};

/**
* | output |
* | --- |
* | "Review your settings" |
*
* @param {New_Project_Confirm_Step_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_step_heading = /** @type {((inputs?: New_Project_Confirm_Step_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_Step_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_confirm_step_heading(inputs)
	if (locale === "de") return de_new_project_confirm_step_heading(inputs)
	if (locale === "it") return it_new_project_confirm_step_heading(inputs)
	if (locale === "ru") return ru_new_project_confirm_step_heading(inputs)
	if (locale === "es") return es_new_project_confirm_step_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_confirm_step_heading(inputs)
	if (locale === "ja") return ja_new_project_confirm_step_heading(inputs)
	if (locale === "hi") return hi_new_project_confirm_step_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_confirm_step_heading(inputs)
	return en_new_project_confirm_step_heading(inputs)
});